module.exports = __webpack_public_path__ + "static/img/IS@3x.6db8060d.jpg";